import React from "react";

const PAGES = {
  terms: {
    title: "Terms and Conditions",
    body: `Welcome to TeachMeOnline.ca. By using our website and services, you agree to the following terms.

1. Educational use only
Our courses provide general educational information. They are not accredited, government-approved, or licensed. We do not guarantee employment, immigration outcomes, or professional certification.

2. Account
You are responsible for maintaining the confidentiality of your account credentials.

3. Payments
Course prices are listed in USD. By purchasing, you agree to pay the listed amount and grant us the right to process payment via Stripe.

4. Intellectual property
Course content is owned by TeachMeOnline.ca and licensed for personal, non-commercial use.

5. Acceptable use
You may not redistribute, resell, or share course content.

6. Limitation of liability
TeachMeOnline.ca is provided "as is". We are not liable for any decisions made based on course content.

7. Changes
We may update these terms from time to time. Continued use means acceptance.

Contact: info@teachmeonline.ca | teachmeonlineca@gmail.com`,
  },
  privacy: {
    title: "Privacy Policy",
    body: `We respect your privacy. This policy explains what we collect and how we use it.

What we collect:
- Account info: name, email, hashed password
- Purchase info: payment transaction id, course id (processed by Stripe; we do not store full card data)
- Learning activity: lessons completed, quiz scores, AI tutor messages

How we use it:
- To deliver and improve our courses
- To communicate about your account and purchases
- For analytics in aggregate form

Sharing:
- We do not sell your data
- We share minimum required data with Stripe (payments) and our AI provider (for tutor and course generation features only)

Your rights:
- Access and delete your account by contacting info@teachmeonline.ca

Security:
- Passwords are hashed; transport is encrypted with HTTPS.`,
  },
  refund: {
    title: "Refund Policy",
    body: `We want you to be happy with your purchase.

1. Eligibility
You may request a refund within 14 days of purchase if you have completed less than 25% of a course's content.

2. How to request
Email info@teachmeonline.ca from your account email with your order ID and course name.

3. Processing
Approved refunds are processed via Stripe within 5–10 business days.

4. Non-refundable
Bundles or discounted courses may be non-refundable; this will be clearly noted.

5. AI-generated personalized courses
On-demand generated courses may have different terms; see course detail page at time of purchase.`,
  },
};

export default function StaticPage({ pageKey }) {
  const page = PAGES[pageKey] || PAGES.terms;
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={`page-${pageKey}`}>
      <div className="label-eyebrow">Legal</div>
      <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">{page.title}</h1>
      <article className="mt-8 text-[#4B5563] whitespace-pre-line leading-relaxed">{page.body}</article>
    </div>
  );
}
